import React, { useState, useContext } from 'react';
import { ContextUserProfile } from '../../../contexts/UserProfileContext';
import Button from '../../../muiComponents/Button';
import { Menu, MenuItem } from '@mui/material';
import Flag from './Flag';

export default function LanguagesDropdown({ languages, handleAddDescription }) {
    const { translate } = useContext(ContextUserProfile);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                id='menu-button'
                variant='contained'
                onClick={handleClick}
                sx={{ whiteSpace: 'nowrap', height: 32 }}
            >
                {translate('add_description')}
            </Button>
            <Menu
                id='language-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {languages.map(lang => (
                    <MenuItem
                        key={lang.id}
                        onClick={() => {
                            handleClose();
                            handleAddDescription(lang);
                        }}
                        className='flex gap-10'
                    >
                        <Flag text={lang.name} code={lang.cultureId} />
                        {lang.name}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
